module.exports = __webpack_public_path__ + "static/media/gallerium.3f06d15e.png";